export const SERVICE_NATURE_ID = 10650;
